/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rotate-left': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.185 6.634a.54.54 0 0 1-.821.697L2.662 4.674l-.064-.075a.54.54 0 0 1 .057-.69l2.703-2.747.074-.064a.54.54 0 0 1 .69.057l.063.074c.148.21.13.501-.057.69L4.324 3.756h10.679c1.514 0 2.741 1.158 2.741 2.586v12.14c0 .286-.245.518-.548.518-.303 0-.548-.232-.548-.517V6.343c0-.858-.737-1.553-1.645-1.553H4.322l1.8 1.77.063.074z" _fill="#0D204A"/>'
  }
})
